import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ACTIVITY_STATUS_COLOR } from '../../constants/constants';
import { TableColumn } from '../../models/shared.model';

@Component({
    selector: 'app-table',
    standalone: false,
    templateUrl: './table.component.html',
    styleUrl: './table.component.scss'
})
export class TableComponent implements OnChanges {
    @Input() tableRecord: any[] = [];
    @Input() columns: TableColumn[] = [];
    @Input({ required: true }) entity: any;
    @Input() selectedRow: any = [];
    @Input() activePageIndex = 0;
    @Input() pageSize = 10;
    @Input() isGroup = false;
    @Input() groupConfig: any = [];
    @Input() groupMatColumnDef: any = [];

    @Output() onSortingChange = new EventEmitter<Sort>();
    @Output() onRowClick = new EventEmitter<any>();
    @Output() onLinkClick = new EventEmitter<{ field: string; row: any }>();
    @Output() onSelectionChange = new EventEmitter<any>();
    @Output() customColumnEvent = new EventEmitter<any>();
    @Output() customActionEvent = new EventEmitter<any>();

    displayColumns: any[] = [];
    dataSource = new MatTableDataSource(this.tableRecord);
    selection = new SelectionModel<any>(true, []);
    protected defaultDateFormat: any = 'dd/MM/yyyy';
    protected ACTIVITY_STATUS_COLOR: any = ACTIVITY_STATUS_COLOR;

    ngOnChanges(changes: SimpleChanges) {
        console.log('defaultDateFormat:', this.defaultDateFormat);
        if (changes['tableRecord']) {
            this.dataSource = new MatTableDataSource(this.tableRecord);
        }

        if (changes['columns']) {
            this.prepareColumnForShow();
        }

        if (changes['selectedRow']) {
            this.selection = new SelectionModel<any>(true, this.selectedRow);
        }
    }

    prepareColumnForShow() {
        this.displayColumns = [];
        this.columns?.forEach((obj: any) => {
            this.displayColumns.push(obj.field);
        });
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    toggleAllRows() {
        if (this.isAllSelected()) {
            this.selection.clear();
            this.onSelectionChange.emit(this.selection.selected);
            return;
        }

        this.selection.select(...this.dataSource.data);
        this.onSelectionChange.emit(this.selection.selected);
    }

    toggleRowsSelection(row: any) {
        this.selection.toggle(row);
        this.onSelectionChange.emit(this.selection.selected);
    }

    /** The label for the checkbox on the passed row */
    checkboxLabel(row?: any): string {
        if (!row) {
            return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    }

    /**
     * rowClick handler
     * @param row
     */
    rowClick(row: any) {
        this.onRowClick.emit(row);
    }

    /**
     * sortData
     * @param event
     */
    sortData(event: Sort) {
        this.onSortingChange.emit(event);
    }

    linkClick(field: string, row: any) {
        this.onLinkClick.emit({ field, row });
    }

    getStatusColor(status: any) {
        if (status.toLowerCase() == 'approved') {
            return '#1B5E20';
        }
        if (status.toLowerCase() == 'pending') {
            return '#B34700';
        }
        if (status.toLowerCase() === 'in_progress') {
            return '#0D47A1';
        }
        if (status.toLowerCase() == 'modified') {
            return '#FF6F00';
        }
        if (status.toLowerCase() == 'closed') {
            return '#B71C1C';
        }
        if (status.toLowerCase() === 'disbursed') {
            return '#512DA8';
        }
        if (status.toLowerCase() === 'received') {
            return '#1B5E20';
        }
        if (status.toLowerCase() === 'rejected') {
            return '#B71C1C';
        }
        if (status.toLowerCase() === 'draft') {
            return '#4E342E';
        }
        if (status.toLowerCase() === 'completed') {
            return '#2E7D32';
        }
        if (status.toLowerCase() === 'active') {
            return '#006064';
        }
        if (status.toLowerCase() === 'paid') {
            return '#04642C';
        }
        if (status.toLowerCase() === 'settled') {
            return '#0E7E39';
        }

        return '#000';
    }

    getStatusBgColor(status: any) {
        if (status.toLowerCase() == 'approved') {
            return '#EDFFEE';
        }
        if (status.toLowerCase() == 'pending') {
            return '#FFF4E6';
        }
        if (status.toLowerCase() === 'in_progress') {
            return '#E3F2FD';
        }
        if (status.toLowerCase() === 'modified') {
            return '#FFF8E1';
        }
        if (status.toLowerCase() === 'closed') {
            return '#FFEFF1';
        }
        if (status.toLowerCase() === 'disbursed') {
            return '#F5EEFF';
        }
        if (status.toLowerCase() === 'received') {
            return '#F3FFF4';
        }
        if (status.toLowerCase() === 'rejected') {
            return '#FFEFF1';
        }
        if (status.toLowerCase() === 'draft') {
            return '#EFEBE9';
        }
        if (status.toLowerCase() === 'completed') {
            return '#F3FFF4';
        }
        if (status.toLowerCase() === 'active') {
            return '#EAFDFF';
        }
        if (status.toLowerCase() === 'paid') {
            return '#E9FFF2';
        }
        if (status.toLowerCase() === 'settled') {
            return '#EAFFF0';
        }

        return '#FFFF';
    }

    isStatus(value: any): boolean {
        const statuses = [
            'approved',
            'pending',
            'in_progress',
            'modified',
            'closed',
            'disbursed',
            'received',
            'rejected',
            'draft',
            'completed',
            'active',
            'paid',
            'settled'
        ];
        return value && statuses.includes((value + '').toLowerCase());
    }
}
